module.exports = "---\nsummary: Defines common messages that are used by other packages.\n---\n"


//////////////////
// WEBPACK FOOTER
// ./node_modules/raw-loader!./src/reference/content/happyco.type.v1/overview.md
// module id = 252
// module chunks = 0